import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { setupStore } from './store/configureStore';
import SelfServiceWrapperComponent from './containers/SelfServiceWrapperComponent';

const store = setupStore();
const rootElement = document.querySelector('.app-user-registration-container');
 
const root = createRoot(rootElement!);
root.render(
  <StrictMode>
    <Provider store={store}>
      <SelfServiceWrapperComponent />
    </Provider>
  </StrictMode>,
);
